module.exports = __webpack_public_path__ + "static/media/store-food-4-less.f524761c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/whereToBuy/stores/store-food-4-less.jpg
// module id = 220
// module chunks = 0